import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Object3D } from '../core/Object3D.js';

var Scene = /*#__PURE__*/function (_Object3D) {
  _inherits(Scene, _Object3D);

  var _super = _createSuper(Scene);

  function Scene() {
    var _this;

    _classCallCheck(this, Scene);

    _this = _super.call(this);
    Object.defineProperty(_assertThisInitialized(_this), 'isScene', {
      value: true
    });
    _this.type = 'Scene';
    _this.background = null;
    _this.environment = null;
    _this.fog = null;
    _this.overrideMaterial = null;
    _this.autoUpdate = true; // checked by the renderer

    if (typeof __THREE_DEVTOOLS__ !== 'undefined') {
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
        detail: _assertThisInitialized(_this)
      })); // eslint-disable-line no-undef

    }

    return _this;
  }

  _createClass(Scene, [{
    key: "copy",
    value: function copy(source, recursive) {
      _get(_getPrototypeOf(Scene.prototype), "copy", this).call(this, source, recursive);

      if (source.background !== null) this.background = source.background.clone();
      if (source.environment !== null) this.environment = source.environment.clone();
      if (source.fog !== null) this.fog = source.fog.clone();
      if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
      this.autoUpdate = source.autoUpdate;
      this.matrixAutoUpdate = source.matrixAutoUpdate;
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(meta) {
      var data = _get(_getPrototypeOf(Scene.prototype), "toJSON", this).call(this, meta);

      if (this.background !== null) data.object.background = this.background.toJSON(meta);
      if (this.environment !== null) data.object.environment = this.environment.toJSON(meta);
      if (this.fog !== null) data.object.fog = this.fog.toJSON();
      return data;
    }
  }]);

  return Scene;
}(Object3D);

export { Scene };